import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdmin } from '../../contexts/AdminContext';
import { Spinner, Container } from 'react-bootstrap';

interface RequireAttorneyProps {
  children: React.ReactNode;
}

/**
 * Route guard that only allows Attorney users.
 * Redirects non-attorneys to their appropriate pages.
 */
const RequireAttorney: React.FC<RequireAttorneyProps> = ({ children }) => {
  const { isAttorney, isAdmin, isSuperAdmin, isOrgAdmin, isLoading } = useAdmin();

  if (isLoading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3 text-muted">Loading...</p>
      </Container>
    );
  }

  // If user is an admin (not an attorney), redirect to regular cases
  if (isAdmin || isSuperAdmin || isOrgAdmin) {
    return <Navigate to="/cases" replace />;
  }

  // If user is an attorney, show the content
  if (isAttorney) {
    return <>{children}</>;
  }

  // Regular users (not attorney, not admin) - redirect to cases
  // In the future, we might want different behavior here
  return <Navigate to="/cases" replace />;
};

export default RequireAttorney;

